module.exports = __webpack_public_path__ + "static/img/class-race-graduate-recruitment.8482dd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/class-race-graduate-recruitment.png
// module id = DLcW
// module chunks = 0